var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPadlockClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.92375 2.1272C7.83923 2.1272 6.96011 3.00632 6.96011 4.09084V6.05452H10.8874V4.09084C10.8874 3.00632 10.0083 2.1272 8.92375 2.1272ZM5.97829 4.09084V6.05452H3.51855V16.8648H14.3289V6.05452H11.8692V4.09084C11.8692 2.46407 10.5505 1.14539 8.92375 1.14539C7.29698 1.14539 5.97829 2.46407 5.97829 4.09084ZM4.50037 7.03633V15.883H13.3471V7.03633H4.50037ZM8.43284 8.0329V11.9601H9.41466V8.0329H8.43284Z",
    fill: "#FCFCFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlockClosed);
export default __webpack_public_path__ + "static/media/padlock-closed.5f3b8d9404862959d434d45afdc3adc8.svg";
export { ForwardRef as ReactComponent };